import { App, Component } from "@vue/runtime-core";

function getTitle(vm: Record<string, any>) {
  const { title } = vm.$options;
  if (title) {
    return typeof title === "function" ? title.call(vm) : title;
  }
}

export const TitleMixin = {
  created() {
    const title = getTitle(this);
    if (title) {
      document.title = title;
    }
  },
};
